import { create } from "zustand";
import useAuthStore from "./useAuthStore";
import useSpaceStore from "./useSpaceStore";
import useUtilStore from "./useUtilStore";
import useOnboardingStore from "./useOnboardingStore";
import { createClient } from "@/utils/supabase/client";

const initialState = {
  session: null,
  loading: true,
  past: [],
  future: [],
  actions: [],
  currentIndex: -1,
  isMaintenanceMode: false,
  isMaintenanceModeLoading: true,
  debugModeEnabled: false,
};

const store = create((set, get) => ({
  ...initialState,
  ...useUtilStore(set, get),
  ...useAuthStore(set, get),
  ...useSpaceStore(set, get),
  ...useOnboardingStore(set, get),
  setDebugModeEnabled: (enabled) => set({ debugModeEnabled: enabled }),
  checkMaintenanceMode: async () => {
    try {
      const supabase = createClient();
      const { data, error } = await supabase
        .from("system_utils")
        .select("*")
        .single();

      if (error) {
        console.error("Error fetching maintenance mode:", error);
        set({ isMaintenanceMode: false, isMaintenanceModeLoading: false });
        return false;
      }

      set({
        isMaintenanceMode: data?.maintenance_mode || false,
        isMaintenanceModeLoading: false,
      });
      return data?.maintenance_mode || false;
    } catch (error) {
      console.error("Error checking maintenance mode:", error);
      set({ isMaintenanceMode: false, isMaintenanceModeLoading: false });
      return false;
    }
  },
}));

// Helper to safely use store on server
const useStore = typeof window !== "undefined" ? store : () => initialState;

export default useStore;
